import React, { useState } from "react";
import bgImg from "../../assets/images/bgImg.png";
import brandLogo from "../../assets/logos/brandLogo.svg";
import AuthButton from "../../components/common/commonButtons/authButton";

const EmailVerify: React.FC = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
 const [error, setErrors] = useState<any>({
  errors: {
    passwordError: "",
    confirmPasswordError: "",
    validationError: "",
  },
  });
  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { passwordError: "", confirmPasswordError: "", validationError: "" };
  
    if (otp.some((digit) => digit.trim() === "")) {
      newErrors.validationError = "OTP must not be empty.";
      isValid = false;
    }
  
    setErrors((prev: any) => ({ ...prev, errors: newErrors }));
    return isValid;
  };
  
  const handleSubmit =() =>{
    console.log("verification submit check");
    if (!validateForm()) return;
    
  }

  return (
    <div
      className="flex justify-center items-center w-full h-screen bg-cover bg-center text-white"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="!w-[400px] flex justify-center items-center bg-authContainerBg border border-authContainerBg rounded-2xl">
        <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center text-center !my-[2rem]">
          <img src={brandLogo} alt="Awesome-Logo" className="mb-2 w-[1.7rem]" />
          <p className="font-bold text-[1.3rem] !my-[1rem]">Verification !</p>
          <p className="text-[0.7rem] w-[80%]">
            Please enter 4 digit code that send to your email address
          </p>

          {/* OTP Fields */}
          <div className="flex gap-4 !mt-5 !mb-3">
            {otp.map((value, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                value={value}
                maxLength={1}
                onChange={(e) => handleChange(e.target.value, index)}
                className="w-10 h-10 text-center text-black  bg-[#F4F4F4] text-[0.8rem] font-semibold outline-none"
              />
            ))}
          </div>

          <p className="text-[0.7rem]">
            If you didn't receive a code ,
            <span className="text-[#3AC4BD] cursor-pointer !ml-1">Resend</span>
          </p>
          {error.errors.validationError && (
            <p className="text-red-500 text-xs">{error.errors.validationError}</p>
          )}
          <div className="mt-5 w-full">
            <AuthButton 
            onClick={handleSubmit}
              message={"Verify And Proceed"}
              classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-semibold !text-[0.7rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem] !mt-[1rem]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerify;
